.status-chart-content {
  text-align: center;
  .status-message-chart {
    display: inline-flex;

    .status-message-div {
      padding: calc(var(--spacer));
      display: grid;
      text-align: left;
      flex-wrap: wrap;
    }
  }
}
